import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const Sidebar = () => {
  const location = useLocation();
  const isResidentPortal = location.pathname === '/resident-dashboard' || location.pathname === '/resident-messages';
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (isResidentPortal) {
      fetchUnreadCount();
    }
  }, [isResidentPortal]);

  const fetchUnreadCount = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data, error } = await supabase
          .from('messages')
          .select('id')
          .eq('recipient_id', user.id)
          .eq('status', 'unread');
        
        if (!error) {
          setUnreadCount(data?.length || 0);
        }
      }
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  const adminMenuItems = [
    { path: '/owner-dashboard', label: 'Dashboard', icon: '⌂' },
    { path: '/properties', label: 'Properties', icon: '☖' },
    { path: '/residents', label: 'Residents', icon: '⌘' },
    { path: '/leasing', label: 'Leasing', icon: '⌨' },
    { path: '/maintenance', label: 'Maintenance', icon: '⚙' },
    { path: '/accounting', label: 'Accounting', icon: '∆' },
    { path: '/communications', label: 'Communications', icon: '✉' },
    { path: '/reports', label: 'Reports', icon: '✓' },
    { path: '/calendar', label: 'Calendar', icon: '☷' },
    { path: '/settings', label: 'Settings', icon: '⚒' }
  ];

  const residentMenuItems = [
    { path: '/resident-dashboard', label: 'Dashboard', icon: '⌘' },
    { path: '/resident-messages', label: 'Messages', icon: '✉' }
  ];

  const menuItems = isResidentPortal ? residentMenuItems : adminMenuItems;

  return (
    <div style={{
      width: '250px',
      height: '100vh',
      background: '#2c3e50',
      color: 'white',
      position: 'fixed',
      left: 0,
      top: 0,
      paddingTop: '80px',
      zIndex: 1000
    }}>
      <div style={{ padding: '20px 0' }}>
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '15px 20px',
              color: 'white',
              textDecoration: 'none',
              background: location.pathname === item.path ? '#34495e' : 'transparent',
              borderLeft: location.pathname === item.path ? '4px solid #3498db' : '4px solid transparent'
            }}
          >
            <span style={{ marginRight: '12px', fontSize: '16px', opacity: 0.9 }}>{item.icon}</span>
            {item.label}
            {item.path === '/resident-messages' && unreadCount > 0 && (
              <span style={{
                marginLeft: 'auto',
                padding: '2px 6px',
                background: '#dc3545',
                color: 'white',
                borderRadius: '10px',
                fontSize: '10px',
                fontWeight: 'bold'
              }}>
                {unreadCount}
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;